/**
 * In-memory GET cache with inflight coalescing.
 * A page refresh clears it; failed requests are not stored.
 */
const memory = new Map();
const inflight = new Map();

export const cachedGet = (key, loader) => {
  if (memory.has(key)) {
    return Promise.resolve(memory.get(key));
  }

  if (inflight.has(key)) {
    return inflight.get(key);
  }

  const request = Promise.resolve()
    .then(loader)
    .then((value) => {
      memory.set(key, value);
      return value;
    })
    .finally(() => {
      inflight.delete(key);
    });

  inflight.set(key, request);
  return request;
};
